import { Result } from 'antd';
import { useAuth } from '@/lib/auth';
import type { ReactNode } from 'react';

export function RequireSuperAdmin({ children }: { children: ReactNode }) {
  const { isSuperAdmin } = useAuth();
  if (!isSuperAdmin) {
    return (
      <Result
        status="403"
        title="Super admin only"
        subTitle="This page requires the super_admin role."
      />
    );
  }
  return <>{children}</>;
}
